import React, { Component } from 'react';
import { Route, Router, Switch, withRouter } from 'react-router';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import withRole from 'components/Security/withRole';
import { ROLE_SHOW_ORDER } from 'helpers/roles';

import List from './Subscriptions.container.js';

class Diets extends Component {
  render() {
    const { props } = this;

    const ListSecured = withRole(ROLE_SHOW_ORDER, List);

    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(Diets);
